export default __webpack_public_path__ + "static/media/opel.11fb0270.webp";